import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { GroupEffects } from './group.effects';
import { groupsReducer } from './group.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('groups', groupsReducer), EffectsModule.forFeature([GroupEffects])],
  providers: [],
})
export class GroupStoreModule {}
